
import axiosAuthConfig from '../../axiosAuthConfig';

export const updateProfile = async (data) => {
    try {
        const response = await axiosAuthConfig.patch(`/api/user/updateProfile`,data); // Call your protected API endpoint
        return response.data; // Return the data from the response
    } catch (error) {
        console.log('Error fetching protected data:', error);
        // throw error; // Handle error appropriately
        
    }
};